/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';

/**
 * 
 * @export
 * @interface ProductListCreateRequest
 */
export interface ProductListCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ProductListCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductListCreateRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ProductListCreateRequest
     */
    externalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductListCreateRequest
     */
    supplierId?: string;
    /**
     * 
     * @type {Status}
     * @memberof ProductListCreateRequest
     */
    status?: Status;
}

/**
 * Check if a given object implements the ProductListCreateRequest interface.
 */
// @ts-ignore
export function instanceOfProductListCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

// @ts-ignore
export function ProductListCreateRequestFromJSON(json: any): ProductListCreateRequest {
    return ProductListCreateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductListCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListCreateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'externalCode': !exists(json, 'external_code') ? undefined : json['external_code'],
        'supplierId': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'status': !exists(json, 'status') ? undefined : StatusFromJSON(json['status']),
    };
}

// @ts-ignore
export function ProductListCreateRequestToJSON(value?: ProductListCreateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'external_code': value.externalCode,
        'supplier_id': value.supplierId,
        'status': StatusToJSON(value.status),
    };
}

